import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Badge } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../utils/helpers";
import { NAV_HEIGHT } from "./MainLayout";

export default function BottomCartBar({ currency }) {
  const navigate = useNavigate();
  const { itemCount, total } = useCart();

  if (itemCount === 0) return null;

  return (
    <Paper
      elevation={6}
      onClick={() => navigate("/cart")}
      sx={{
        position: "fixed",
        left: 16,
        right: 16,
        bottom: NAV_HEIGHT + 16,
        p: 1.5,
        borderRadius: 3,
        bgcolor: "primary.main",
        color: "primary.contrastText",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        zIndex: 10,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Badge badgeContent={itemCount} color="default" sx={{ "& .MuiBadge-badge": { bgcolor: "#fff", color: "primary.main" } }}>
          <ShoppingCart />
        </Badge>
        <Typography fontWeight={700}>View Cart</Typography>
      </Box>
      <Typography fontWeight={700}>{formatPrice(total, currency)}</Typography>
    </Paper>
  );
}
